import {createContext, type MutableRefObject} from 'react'

export interface FileAttachParams {
  path: string
  repoOwner: string
  repoName: string
  repoId: number
  ref: string
  commitOID: string
}

export type FileAttachHandler = (params: FileAttachParams) => void

/**
 * Holds a mutable ref to the active writable composer's file-attach handler.
 * Read-only and blocked composers do not register. Sibling components
 * (e.g. ResourcePanel FileTab) call it only on explicit file selection
 * to attach a file to the chat input without prop-drilling through intermediate
 * components.
 */
export const FileAttachContext = createContext<MutableRefObject<FileAttachHandler | null> | null>(null)
